import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';

class ActivityModal extends React.Component {
  state = {};

  renderModalContent = () => {
    const { actions, userEmail, messageError, from, to } = this.props;

    // Actions related to changes in rate/rank/duty status
    const changeActions = [
      'rateChanged',
      'rateChangedByUser',
      'rankChanged',
      'dutyStateChanged',
      'subscriptionImmediateChanged',
    ];

    if (changeActions.includes(actions)) {
      return (
        <div className="ActivityContainer">
          <Row className="py-3">
            <Col className="col-4 pl-4">User</Col>
            <Col className="col-4 pl-4">Action</Col>
            <Col className="col-2 pl-4">From</Col>
            <Col className="col-2 pl-4">To</Col>
          </Row>
          <div className="separatorLine" />
          <Row className="py-3">
            <Col className="col-4 pl-4 wrap-text">{userEmail}</Col>
            <Col className="col-4 pl-4 wrap-text">{actions}</Col>
            <Col className="col-2 pl-4 wrap-text">{from || 'N/A'}</Col>
            <Col className="col-2 pl-4 wrap-text">{to || 'N/A'}</Col>
          </Row>
        </div>
      );
    }

    return (
      <div className="ActivityContainer">
        <Row className="py-3">
          <Col className="col-4 pl-4">User</Col>
          <Col className="col-4 pl-4">Action</Col>
          <Col className="col-4 pl-4">
            {actions === 'subscriptionCancelFailed'
              ? 'Error message'
              : 'Stripe subscription'}
          </Col>
        </Row>
        <div className="separatorLine" />
        <Row className="py-3">
          <Col className="col-4 pl-4 wrap-text">{userEmail}</Col>
          <Col className="col-4 pl-4 wrap-text">{actions}</Col>
          <Col className="col-4 pl-4 wrap-text">{messageError}</Col>
        </Row>
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.renderModalContent()}
        <Row className="py-3">
          <Col className="float-right">
            <Button
              className="btn-primary float-right"
              onClick={this.props.closeModal}
            >
              Close
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ActivityModal;
